import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { Program } from "@/store/modules/ProgramModule";

interface Links {
  website?: string;
  telegram?: string;
  whatsapp?: string;
  instagram?: string;
}

export interface Channel {
  id: number;
  user_id: number;
  slug: string;
  title: string;
  about: string;
  files: string[];
  links: Links;
  programs: Program[];
  created_at: string;
  updated_at: string;
}

export interface channelSchedule {
  id: number;
  start: string;
  end?: string;
}

export interface ChannelsInfo {
  channelData: Channel;
  channelSchedulesData: channelSchedule[];
}

@Module
export default class ChannelModule extends VuexModule implements ChannelsInfo {
  channelData = {} as Channel;
  channelSchedulesData = [];

  get channel(): Channel {
    return this.channelData;
  }

  get channelSchedules(): channelSchedule[] {
    return this.channelSchedulesData;
  }

  @Mutation
  [Mutations.SET_CHANNEL](payload) {
    this.channelData = payload;
  }

  @Mutation
  [Mutations.SET_CHANNEL_SCHEDULES](payload) {
    this.channelSchedulesData = payload;
  }

  @Action({ rawError: true })
  [Actions.FETCH_CHANNEL](slug) {
    return new Promise<void>((resolve, reject) => {
      ApiService.get("public/v2/media/channels", slug)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CHANNEL, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Actions.FETCH_CHANNEL_SCHEDULES](id) {
    return new Promise<void>((resolve, reject) => {
      ApiService.get(`public/v2/media/channels/${id}/schedules`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CHANNEL_SCHEDULES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
}
